import { nanoid } from "nanoid"
import * as configcat from "configcat-js-ssr"

export async function useFeatureFlag(featureFlagKey: string) {
  // Resolve the flag once and cache it in Nuxt state, so it is evaluated on the
  // server and the value is serialized to (and reused by) the client. Evaluating
  // again during client hydration can return a different result — a cold or
  // failed ConfigCat fetch defaults to `false` — which flips SSR-gated UI and
  // causes a hydration mismatch/flicker. `null` marks "not yet evaluated"
  // (distinct from an evaluated `false`); a client-side navigation with no
  // serialized value falls through and evaluates on the client.
  const flag = useState<boolean | null>(`featureFlag:${featureFlagKey}`, () => null)

  if (flag.value === null) {
    const { $configCat } = useNuxtApp()
    const { tenantId } = useHeaderStore()

    flag.value = await $configCat.getValueAsync(
      featureFlagKey,
      false,
      new configcat.User(nanoid(), "", "", {
        tenantId,
      }),
    )
  }

  return flag.value ?? false
}
